"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var LayoutStyles_1 = require("../../../style/LayoutStyles");
var StyleFunctions_1 = require("../../../style/StyleFunctions");
var VizPortalStyles_1 = require("../../../style/VizPortalStyles");
var SiteUrlsContext_1 = require("../../../urls/SiteUrlsContext");
var CellStyles_1 = require("./CellStyles");
var TextCellFormatter_1 = require("./TextCellFormatter");
exports.linkCellClass = StyleFunctions_1.cssClass('linkCell', LayoutStyles_1.elideTextStyle, CellStyles_1.cellPaddingStyle);
exports.noPaddingLinkCellClass = StyleFunctions_1.cssClass('noPaddingLinkCell', LayoutStyles_1.elideTextStyle);
function LinkCellFormatter(_a) {
    var text = _a.text, pathname = _a.pathname, noPadding = _a.noPadding, _b = _a.targetBlank, targetBlank = _b === void 0 ? false : _b, _c = _a.useAnchor, useAnchor = _c === void 0 ? false : _c;
    return (React.createElement("div", { className: noPadding ? exports.noPaddingLinkCellClass : exports.linkCellClass }, useAnchor
        ? React.createElement("a", { className: VizPortalStyles_1.linkClass, href: pathname, title: text || undefined, target: targetBlank ? '_blank' : undefined }, text)
        : React.createElement(react_router_dom_1.Link, { className: VizPortalStyles_1.linkClass, to: pathname, title: text || undefined, target: targetBlank ? '_blank' : undefined }, text)));
}
exports.LinkCellFormatter = LinkCellFormatter;
function createLinkCellFormatter(getTextFromRowData, getPathFromRowData, noPadding, useAnchor) {
    if (noPadding === void 0) { noPadding = false; }
    if (useAnchor === void 0) { useAnchor = false; }
    return function (props) { return (React.createElement(SiteUrlsContext_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement(LinkCellFormatter, { text: getTextFromRowData(props.row.data), pathname: getPathFromRowData(urls, props.row.data), noPadding: noPadding, useAnchor: useAnchor });
    })); };
}
exports.createLinkCellFormatter = createLinkCellFormatter;
function createLinkOrTextCellFormatter(getTextFromRowData, getPathFromRowData, noPadding, targetBlank, useAnchor) {
    if (noPadding === void 0) { noPadding = false; }
    if (targetBlank === void 0) { targetBlank = false; }
    if (useAnchor === void 0) { useAnchor = false; }
    return function (props) { return (React.createElement(SiteUrlsContext_1.SiteUrlsContext.Consumer, null, function (urls) {
        var text = getTextFromRowData(props.row.data);
        var url = getPathFromRowData(urls, props.row.data);
        if (url) {
            return React.createElement(LinkCellFormatter, { text: text, pathname: url, noPadding: noPadding, targetBlank: targetBlank, useAnchor: useAnchor });
        }
        else {
            return React.createElement(TextCellFormatter_1.TextCellFormatter, { text: text, noPadding: noPadding });
        }
    })); };
}
exports.createLinkOrTextCellFormatter = createLinkOrTextCellFormatter;
//# sourceMappingURL=LinkCellFormatter.js.map